module.exports = __webpack_public_path__ + "img/211122_TNP_Campaign-Promo_Section_Handschuh_2.5c5a5aa1.png";